import request from '@/axios/http'

// 获取下一期期号（type: 0=双色球，1=大乐透）
export function getNextPeriod (type) {
	return request({
		url: '/stage-api/lottery/result/next/period',
		method: 'get',
		params: { type }
	})
}

// 获取期号
export function queryNumber (type) {
	return request({
		url: '/stage-api/lottery/consult/queryColorfulSeedMaxByType/' + type,
		method: 'get',
	})
}
// 编辑用户信息
export function editCurrentUser (data) {
	return request({
		url: '/stage-api/system/user/editCurrentUser',
		data,
		method: 'put',
	})
}


// 获取当前用户查询新消息（收件箱）
export function queryCurrentUserMessage () {
	return request({
		url: '/stage-api/notify/preOffMail/queryCurrentUserMessage',
		method: 'get',
	})
}

// 缩水师预测
export function savePreRecordInfo (data) {
	return request({
		url: '/stage-api/pre/record/savePreRecordInfo',
		method: 'post',
		data
	})
}

// 缩水师预测明细
export function yucemingxi_detailList (params) {
	return request({
		url: '/stage-api/pre/detail/list',
		method: 'get',
		params
	})
}

// 帮扶中心实战超市
export function schemelist (params) {
	return request({
		// url: '/stage-api/assist/market/scheme/list',
		url: '/stage-api/assist/market/list',
		method: 'get',
		params
	})
}


// 查询当前用户所有彩种申请的进度
export function queryLotteryStatus (params) {
	return request({
		url: '/stage-api/cms/identity/infoList',
		method: 'get',
		params
	})
}


// 收入统计
export function incomeRecord (params) {
	return request({
		url: '/stage-api/recharge/income-record',
		method: 'get',
		params
	})
}

// 帮扶实战超市大厅获取团队信息
export function GetLotteryTeam (params) {
	return request({
		url: '/stage-api/assist/market/GetLotteryTeam',
		method: 'get',
		params
	})
}

// 帮扶实战超市大厅根据获取团队名称获取实战团队盈亏战绩
export function GetLotteryList (params) {
	return request({
		url: '/stage-api/assist/market/GetLotteryList',
		method: 'get',
		params
	})
}

// 实战超市方案发布
export function publishScheme (data) {
	return request({
		url: '/stage-api/assist/market/scheme/publish',
		method: 'post',
		data
	})
}

// 查询我发布的实战超市方案列表
export function getMySchemeList (params) {
	return request({
		url: '/stage-api/assist/market/my/list',
		method: 'get',
		params
	})
}

// 上架实战超市方案（Query 参数 marketId）
export function onlineScheme (marketId) {
	return request({
		url: '/stage-api/assist/market/scheme/online',
		method: 'post',
		params: { marketId }
	})
}

// 下架实战超市方案（Query 参数 marketId）
export function offlineScheme (marketId) {
	return request({
		url: '/stage-api/assist/market/scheme/offline',
		method: 'post',
		params: { marketId }
	})
}

// 编辑实战超市方案
export function updateScheme (data) {
	return request({
		url: '/stage-api/assist/market/scheme/update',
		method: 'post',
		data
	})
}

// 删除实战超市方案（Query 参数 marketId）
export function deleteScheme (marketId) {
	return request({
		url: '/stage-api/assist/market/scheme/delete',
		method: 'post',
		params: { marketId }
	})
}

// 增加团队
export function addTeam (data) {
	return request({
		url: '/stage-api/assist/team/add',
		method: 'post',
		data
	})
}

// 删除团队
export function deleteTeam (data) {
	return request({
		url: '/stage-api/assist/team/delete',
		method: 'post',
		data
	})
}

// 查询我的团队成员（用于新增团队时选择成员）
export function getMyTeam (params) {
	return request({
		url: '/stage-api/assist/team/my',
		method: 'get',
		params
	})
}

// 按角色查询用户列表（不传 roleKey 则查询所有用户），用于新增团队时选择成员
export function getUserByRole (params) {
	return request({
		url: '/stage-api/system/user/byRole',
		method: 'get',
		params
	})
}


// 系统消息
export function logininfor (params) {
	return request({
		url: '/stage-api/notify/preOffMail/queryCurrentUserSystemMessage',
		method: 'get',
		params
	})
}

// 投注站众筹招股发布
export function publishOffering (data) {
	return request({
		url: '/stage-api/assist/betting/shop/release/offering',
		method: 'post',
		data
	})
}

// 查询我关联的实战团队方案（用于众筹招股关联方案下拉）
export function getMyPurchaseList (params) {
	return request({
		url: '/stage-api/assist/market/my/purchase/list',
		method: 'get',
		params
	})
}

// 查询我的出票站信息（站号/站点自动带出，不可修改）
// 查询某实战方案买家列表（仅发布者可见）：GET /stage-api/assist/market/{marketId}/buyers
export function getMarketBuyers (marketId) {
	return request({
		url: '/stage-api/assist/market/' + marketId + '/buyers',
		method: 'get'
	})
}

// 我的销售总览（已发布方案 + 买家列表）：GET /stage-api/assist/market/my/sold
export function getMySoldMarkets () {
	return request({
		url: '/stage-api/assist/market/my/sold',
		method: 'get'
	})
}

export function getMyBettingShop () {
	return request({
		url: '/stage-api/assist/betting/shop/my',
		method: 'get'
	})
}